module.exports = __webpack_public_path__ + "media/country_flags/fi-664d9849.png";